export default function PHP_MySQLPrepared() {
  return (
    <div>
      <h1>PHP_MySQLPrepared</h1>
    </div>
  );
}
